import { Campaign, User } from '@ms/yammer-data/dist/state/types';

export const insightsLeadersPage = '/insights/leaders';
export const insightsLeadersOrgPage = '/insights/leaders/all';
export const insightsSelectedLeadersOrgPage = '/insights/leaders/:leaderId';
export const insightsMyInsightsPage = '/insights/users/myInsights';
export const insightsSelectedLeaderMyInsightsPage = '/insights/users/myInsights/leaders/:leaderId';
export const insightsQnAPage = '/insights/qna';
export const insightsQnAOrgPage = '/insights/qna/all';
export const insightsQnAMyInsightsPage = '/insights/qna/myInsights';
export const insightsCampaignPage = '/insights/campaign';
export const insightsNetworkPage = '/insights/network';

type InsightsCampaignPageWithCampaignId = (campaignId: Campaign['id']) => string;
export const insightsCampaignPageWithCampaignId: InsightsCampaignPageWithCampaignId = (campaignId) =>
  `/insights/campaign/${campaignId}`;

type InsightsPersonalWithLeaderId = (leaderId: User['id']) => string;
export const insightsPersonalWithLeaderId: InsightsPersonalWithLeaderId = (leaderId) =>
  insightsSelectedLeaderMyInsightsPage.replace(':leaderId', leaderId);

type InsightsAudienceWithLeaderId = (leaderId: User['id']) => string;
export const insightsAudienceWithLeaderId: InsightsAudienceWithLeaderId = (leaderId) =>
  insightsSelectedLeadersOrgPage.replace(':leaderId', leaderId);
